import { showNetworkDialog } from "@/utils/tools";
import ajax from "@/utils/ajax";

const state = {
  socket: null,
  gameStatus: 0,
  clientId: "",
  dayCount: 0,
  player1: null,
  player2: null,
  currentQuestion: null,
  score1: null,
  score2: null,
  gameResult: null,
  questionList: [],
  closeStatusCode: 0,
};

const getters = {
  errorList: (state) =>
    state.questionList.filter((item) => item.selectAnswer !== item.answer),
};

const mutations = {
  SET_SOCKET(state, socket) {
    state.socket = socket;
  },
  SET_GAME_STATUS(state, status) {
    state.gameStatus = status;
  },
  SET_CLIENT_ID(state, id) {
    state.clientId = id;
  },
  SET_DAY_COUNT(state, count) {
    state.dayCount = count;
  },
  SET_PLAYER1(state, data) {
    state.player1 = data;
  },
  SET_PLAYER2(state, data) {
    state.player2 = data;
  },
  SET_CURRENT_QUESTION(state, question) {
    state.currentQuestion = question;
  },
  SET_SCORE1(state, score) {
    state.score1 = score;
  },
  SET_SCORE2(state, score) {
    state.score2 = score;
  },
  SET_GAME_RESULT(state, result) {
    state.gameResult = result;
  },
  ADD_QUESTION(state, question) {
    state.questionList.push({ ...question });
  },
  UPDATE_QUESTION_ANSWER(state, { qid, answer }) {
    const question = state.questionList.find((item) => item.qid === qid);
    if (question) question.answer = answer;
  },
  UPDATE_QUESTION_SELECT_ANSWER(state, { qid, selectAnswer }) {
    const question = state.questionList.find((item) => item.qid === qid);
    if (question) question.selectAnswer = selectAnswer;
  },
  SET_CLOSE_STATUS_CODE(state, code) {
    state.closeStatusCode = code;
  },
  RESET_STATE(state) {
    Object.assign(state, {
      gameStatus: 0,
      socket: null,
      clientId: "",
      dayCount: 0,
      player1: null,
      player2: null,
      currentQuestion: null,
      score1: null,
      score2: null,
      gameResult: null,
      questionList: [],
      closeStatusCode: 0,
    });
  },
};

const actions = {
  initSocket(
    { commit, state, dispatch, rootState },
    { onMessageCallback } = {}
  ) {
    commit("SET_CLOSE_STATUS_CODE", 0);
    const socket = new WebSocket(process.env.VUE_APP_WEBSOCKET_URL);
    commit("SET_SOCKET", socket);

    socket.onopen = (e) => console.log("连接成功：", e);
    socket.onclose = (e) => {
      console.log("连接关闭：", e);
      if (state.closeStatusCode !== 1000 && state.closeStatusCode !== 3000)
        showNetworkDialog();
      if (state.closeStatusCode == 3000) {
        showNetworkDialog("今日已完成PK答题，请明天再继续参与PK答题！", "关闭");
      }
      if (state.closeStatusCode == 4000) {
        // 清除token并重新获取用户信息
        commit(
          "user/SET_USER",
          { ...rootState.user.user, token: "" },
          { root: true }
        );
        ajax
          .post(`/User/getUserInfo`)
          .then((res) => {
            commit("user/SET_USER", res.data, { root: true });
          })
          .catch((err) => {
            console.log("重新获取用户信息失败：", err);
          });
        showNetworkDialog();
      }
    };
    socket.onmessage = (e) => {
      const res = JSON.parse(e.data);
      console.log("收到消息：", res);
      // Store 内部消息处理
      switch (res.code) {
        case 0:
          commit("SET_CLIENT_ID", res.data.client_id);
          commit("SET_GAME_STATUS", 1);
          break;
        case 1:
          commit(
            Number(res.data.is_me) === 1 ? "SET_PLAYER1" : "SET_PLAYER2",
            res.data
          );
          commit("SET_GAME_STATUS", 2);
          break;
        case 2:
          if (res.data === "开始答题") {
            commit("SET_GAME_STATUS", 3);
          } else {
            commit("SET_GAME_STATUS", 4);
            setTimeout(() => {
              commit("SET_CURRENT_QUESTION", res.data);
              commit("ADD_QUESTION", res.data);
            }, 1000);
          }
          break;
        case 3:
          commit("SET_GAME_STATUS", 4);
          if (Number(res.data.is_me) === 1) {
            commit("SET_SCORE1", res.data);
            commit("UPDATE_QUESTION_ANSWER", {
              qid: res.data.qid,
              answer: res.data.option,
            });
          } else {
            commit("SET_SCORE2", res.data);
          }
          break;
        case 4:
          dispatch("sendMessage", { type: "result" });
          break;
        // 修复：给 case 5 加上 {} 包裹块级作用域
        case 5: {
          if (state.gameStatus === 5) return;
          commit("SET_GAME_STATUS", 5);
          console.log(rootState);
          // const result = Math.sign(
          //   Number(state.score1?.total_score ?? 0) -
          //     Number(state.score2?.total_score ?? 0)
          // );
          // let newScore = 0;
          // if (Number(res.data?.uid) === Number(rootState.user.user.uuid)) {
          //   newScore = res.data?.newScore;
          // }
          // commit("SET_GAME_RESULT", {
          //   newScore,
          //   pk_result: result,
          //   totalScore: 0,
          // });
          setTimeout(() => dispatch("closeSocket", 1000), 1000);
          break;
        }
        case 11:
          commit("SET_DAY_COUNT", Number(res.data));
          break;
        case 102: {
          commit("SET_GAME_RESULT", res.data);
          console.log(state.gameResult, "*&*&*&*&*&*");
          break;
        }
        case 101: {
          // 会出现对手信息 数据，code = 101
          commit("SET_PLAYER2", res.data[Object.keys(res.data)[0]]);
          break;
        }
        case -3: {
          commit("SET_CLOSE_STATUS_CODE", 3000);
          // setTimeout(() => dispatch("closeSocket", 1000), 1000);
          break;
        }
        case -4: {
          commit("SET_CLOSE_STATUS_CODE", 4000);
          // setTimeout(() => dispatch("closeSocket", 1000), 1000);
          break;
        }
        default:
          if (res.type === "ping") dispatch("sendMessage", { type: "pong" });
          break;
      }

      // 执行组件传入的回调
      if (typeof onMessageCallback === "function") {
        onMessageCallback(res);
      }
    };
    socket.onerror = (e) => console.log("连接失败：", e);
  },

  sendMessage({ state }, message) {
    console.log("发送消息：", message);
    state.socket?.send(JSON.stringify(message));
  },

  closeSocket({ commit, state }, code = 1000, reason = "") {
    console.trace("关闭连接");
    commit("SET_CLOSE_STATUS_CODE", code);
    state.socket?.close(code, reason);
    commit("SET_SOCKET", null);
  },

  reset({ commit, dispatch }) {
    commit("RESET_STATE");
    dispatch("closeSocket");
  },

  updateQuestionSelectAnswer({ commit }, payload) {
    commit("UPDATE_QUESTION_SELECT_ANSWER", payload);
  },
};

export default { namespaced: true, state, getters, mutations, actions };
